import React from "react";
import Picture from "../Assets/About.jpg";
import { SlBadge } from "react-icons/sl";
import { BsSuitcaseLg } from "react-icons/bs";
import { BiSupport } from "react-icons/bi";
import { AiOutlineFilePdf } from "react-icons/ai";
import CV from "../Assets/ShreyashCV.pdf";
function About() {
  return (
    <div
      id="about"
      className=" transition-all duration-300 ease-in-out pt-[80px] flex  flex-col items-center
    "
    >
      <div className="text-center mb-[40px]">
        <h1 className="lg:text-4xl text-3xl font-semibold">About Me</h1>
        <p className="lg:text-xl">My Introduction</p>
      </div>

      <div
        className=" flex flex-col items-center
      lg:flex-row lg:justify-around"
      >
        {/* Profile Picture */}
        <div
          className="w-[250px]  rounded-3xl overflow-hidden
        lg:w-[35%]"
        >
          <img src={Picture} alt="about" />
        </div>

        {/* About ME */}
        <div
          className="flex flex-col items-center
        lg:w-1/2 lg:items-start"
        >
          <div className="grid gap-2 my-[40px] grid-cols-3 w-full lg:mt-[0px]">
            <div className="border-2 border-gray-300 space-y-2 rounded-lg flex flex-col items-center py-[10px] px-[5px]">
              <SlBadge fontSize={"1.5rem"} />
              <p className="font-semibold">Experience</p>
              <p>1 + years</p>
            </div>

            <div className="border-2 border-gray-300 space-y-2 rounded-lg flex flex-col items-center py-[10px] px-[5px]">
              <BsSuitcaseLg fontSize={"1.5rem"} />
              <p className="font-semibold">Completed</p>
              <p>15 + Projects</p>
            </div>

            <div className="border-2 border-gray-300 space-y-2 rounded-lg flex flex-col items-center py-[10px] px-[5px]">
              <BiSupport fontSize={"1.5rem"} />
              <p className="font-semibold">Support</p>
              <p>Online 24/7</p>
            </div>
          </div>

          <p className="w-full text-center lg:text-left">
            Frontend developer, I create responsive and user-friendly web
            applications. Proficient in HTML, CSS, JavaScript, and frameworks
            like React.
          </p>

          <a download="ShreyashCV" href={CV}>
            <button className="mt-[40px] flex items-center gap-2 text-white rounded-xl py-[20px] px-[30px] bg-gray-900 transition-all duration-300 hover:bg-black">
              Download CV
              <span>
                <AiOutlineFilePdf fontSize={"1.5rem"} />
              </span>
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}

export default About;
